module.exports = __webpack_public_path__ + "img/button_close_info.b9cf79be.svg";